import ProctoredDataDetails from "./ProctoredDataDetails";
import TrackTimelineDetails from "./TrackTimelineDetails";

const TabSwitching = ({
  setActiveTab,
  activeTab,
  eventdata,
  profileData,
  getProctorData,
  handleSelectImage,
  handleDeleteImg,
  setShowAll,
  showAll,
  deleteImages
}) => {
  const handleTabClick = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="tab-container-switch">
      <div className="tabswitch">
        <span
          className={`tabactive ${activeTab === "activity" ? "living" : ""}`}
          onClick={() => handleTabClick("activity")}
        >
          Activity
        </span>
        <span
          className={`tabactive ${activeTab === "images" ? "living" : ""}`}
          onClick={() => handleTabClick("images")}
        >
          Proctored Images
        </span>
      </div>

      <div className="tab-content-switch">
        {activeTab === "activity" && (
          <TrackTimelineDetails
            eventLogData={eventdata}
            proctoredData={getProctorData()}
          />
        )}
        {activeTab === "images" && (
          <ProctoredDataDetails
            handleSelectImage={handleSelectImage}
            setShowAll={setShowAll}
            showAll={showAll}
            deleteImages={deleteImages}
            getProctorData={getProctorData}
            handleDeleteImg={handleDeleteImg}
          />
        )}
      </div>
    </div>
  );
};

export default TabSwitching;
